import { AddedDiffLine } from "@ext/git/core/Diff/components/DiffLine/AddedDiffLine";
import { BreadcrumbLine } from "@ext/git/core/Diff/components/DiffLine/BreadcrumbLine";
import { DiffLineContainer, type DiffLinePlacement } from "@ext/git/core/Diff/components/DiffLine/DiffLineContainer";
import { DiffLineMarker } from "@ext/git/core/Diff/components/DiffLine/DiffLineMarker";
import { ModifiedDiffLine } from "@ext/git/core/Diff/components/DiffLine/ModifiedDiffLine";
import { generateCommentTooltip } from "@ext/git/core/Diff/logic/commentsDiff/generateCommentTooltip";
import type { ProseMirrorDiffLine } from "@ext/git/core/Diff/logic/model/ProseMirrorDiffLine";
import type { TreeReadScope } from "@ext/git/core/GitCommands/model/GitCommandsModel";
import t from "@ext/localization/locale/translate";

interface DiffLineProps extends DiffLinePlacement {
	diffLine: ProseMirrorDiffLine;
	oldScope: TreeReadScope;
	articlePath: string;
	onDiscard?: () => void;
}

const DiffLine = ({ top, height, left, diffLine, oldScope, articlePath, onDiscard }: DiffLineProps) => {
	const placement = { top, height, left };

	if (diffLine.type === "breadcrumb") return <BreadcrumbLine hunks={diffLine.diff.hunks} placement={placement} />;

	if (diffLine.type === "added" && onDiscard) return <AddedDiffLine onDiscard={onDiscard} placement={placement} />;

	if (diffLine.type === "modified" && diffLine.oldContent)
		return (
			<ModifiedDiffLine
				articlePath={articlePath}
				newContent={diffLine.newContent}
				oldContent={diffLine.oldContent}
				oldScope={oldScope}
				onDiscard={onDiscard}
				placement={placement}
			/>
		);

	const isComment = diffLine.type === "comment";
	return (
		<DiffLineContainer
			placement={placement}
			tooltipOffset={isComment ? [-4, 8] : undefined}
			tooltipText={isComment ? generateCommentTooltip(diffLine.comments) : t(`diff.type.${diffLine.type}`)}
			type={diffLine.type}
		>
			<DiffLineMarker height={height} type={diffLine.type} />
		</DiffLineContainer>
	);
};

export default DiffLine;
